/**
 * Сворачиваемые блоки карточки задачи — состав, порядок и подписи.
 * Общие для веба и приложения: что развёрнуто при открытии, человек
 * выбирает в профиле (me.uiPrefs.expandedTaskSections), и подписи
 * там и в карточке обязаны совпадать.
 *
 * Название и описание не сворачиваются: карточка без них не отвечает
 * на вопрос «что это за задача», а ради него её и открывают.
 */

import { TaskSection } from "@taskflow/contracts";

export const TASK_SECTION_LABELS: Record<TaskSection, string> = {
  [TaskSection.ATTACHMENTS]: "Файлы",
  [TaskSection.LINKS]: "Связанные задачи",
  [TaskSection.PARAMETERS]: "Основные параметры",
  [TaskSection.COMMENTS]: "Комментарии",
  [TaskSection.HISTORY]: "История",
};

/** Порядок блоков в карточке — им же они перечислены в профиле. */
export const TASK_SECTIONS: readonly TaskSection[] = [
  TaskSection.ATTACHMENTS,
  TaskSection.LINKS,
  TaskSection.PARAMETERS,
  TaskSection.COMMENTS,
  TaskSection.HISTORY,
];

/** §14.1: глубина обсуждения — три уровня; на третьем ответить уже нельзя. */
export const MAX_COMMENT_DEPTH = 3;
